import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { CountrySelectionService } from './country-selection.service';
import { ApiConfigService } from './api-config.service';

export interface KnowledgeMenuItem {
  name: string;
  tid: string;
  parent_term_name: string;
  parent_term_id: string;
  description__value_export: string;
  field_icon_image: string;
}

export interface HotTopicItem {
  nid: string;
  title: string;
  field_cover_image: string;
  field_image: string;
  field_short_description: string;
  field_thematic_area_id: string;
  field_thematic_area: string;
  field_child_term: string;
  field_child_term_id: string;
  field_description: string;
  field_age_group: string;
  field_objective: string;
  field_tags: string;
  field_video: string;
  langcode: string;
  field_hot_srh_content: string;
  field_sms_text: string;
  created: string;
  changed: string;
  field_social_media_text: string;
  field_recommended_articles_export: string[];
}

@Injectable({
  providedIn: 'root'
})
export class MyKnowledgeService {

  private menuApiUrl = this.apiConfigService.getApiUrl('srh_context_taxonomy_export');

  constructor(private http: HttpClient, private countrySelectionService: CountrySelectionService, private apiConfigService: ApiConfigService) { }

  getMenuItems(): Observable<KnowledgeMenuItem[]> {
    return this.http.get<KnowledgeMenuItem[]>(this.menuApiUrl);
  }

  getContentByThematicArea(thematicAreaId: string, countryId: string): Observable<any[]> {
    const apiUrl = this.apiConfigService.getApiUrl('hot_topics', '', Number(countryId));
    return this.http.get<any[]>(apiUrl).pipe(
      map(items => {
        return items.filter(item => {
          return String(item.field_thematic_area_id) === String(thematicAreaId);
        });
      })
    );
  }

  getContentByChildTermId(childTermId: string, countryId: string): Observable<any[]> {
    const apiUrl = this.apiConfigService.getApiUrl('hot_topics', '', Number(countryId));
    return this.http.get<any[]>(apiUrl).pipe(
      map(items => {
        return items.filter(item => {
          return String(item.field_child_term_id) === String(childTermId);
        });
      })
    );
  }

  getHotTopics(thematicAreaId?: string, countryId?: string): Observable<HotTopicItem[]> {
    if (countryId) {
      const apiUrl = this.apiConfigService.getApiUrl('hot_topics', '', Number(countryId));
      return this.http.get<HotTopicItem[]>(apiUrl).pipe(
        map((items: HotTopicItem[]) => {
          if (thematicAreaId) {
            return items.filter(item => item.field_thematic_area_id === thematicAreaId);
          }
          return items.filter(item => item.field_hot_srh_content === 'Yes');
        })
      );
    }
    return this.countrySelectionService.selectedCountry$.pipe(
      switchMap(country => {
        const apiUrl = this.countrySelectionService.getApiUrl('hot_topics', country);
        return this.http.get<HotTopicItem[]>(apiUrl).pipe(
          map((items: HotTopicItem[]) => {
            if (thematicAreaId) {
              return items.filter(item => item.field_thematic_area_id === thematicAreaId);
            }
            return items.filter(item => item.field_hot_srh_content === 'Yes');
          })
        );
      })
    );
  }

  getContentById(id: string, countryId: string): Observable<any> {
    const apiUrl = this.apiConfigService.getApiUrl('hot_topics', '', Number(countryId));
    return this.http.get<any[]>(apiUrl).pipe(
      map(items => items.find(item => item.nid === id))
    );
  }
}